import { CommonTranslations } from "./commonTranslations";

export const ruCommonTranslations: CommonTranslations = {
  "opcUa_BadNoData_title": "Ошибка загрузки сообщений",
  "opcUa_BadNoData_text": "{}: Отключено архивирование в настройках архива сообщений",
  "subscription_error": "Недостаточно прав для выполнения действия: Чтение значения: ({})",
  "call_pou_error": 'Невозможно выполнить действие "Вызвать программу"',
  "call_pou_error_rights": "Недостаточно прав для выполнения действия: Вызов программы: (id {})",
  "write_data_error": "Невозможно записать значение параметра",
  "write_data_error_rights": "Недостаточно прав для выполнения действия: Запись значения: (id {})",
  //Main
  "main_connectionServer": "Подключение к серверу...",
  "main_noConnectionServer": "Нет подключения к серверу...",
  "main_connectingBackupNode": "Подключение к резервному узлу...",
  "main_reboot": "Перезагрузка...",
  "main_connectionEstablished": "Соединение установлено",
  "main_connectingTo": "Подключение к",
  "main_successfullyInstalled": "успешно установлено",
  "confirm_the_operation": "Подтвердите операцию",
  // Авторизация
  "authorization_loginFormTitle": "Вход в систему",
  "authorization_loginTitle": "Пользователь",
  "authorization_passwordTitle": "Пароль",
  "authorization_showPasswordTitle": "Показать пароль",
  "authorization_loginError": "Неверный пароль. Проверьте раскладку клавиатуры или клавишу CapsLock.",
  "authorization_wrongPassword": "Неверный пароль.",
  "authorization_needChangePassword": "Необходимо сменить пароль.",
  "authorization_newPassword": "Новый пароль",
  "authorization_repeatPassword": "Повторить пароль",
  "authorization_loginBtn": "Войти",
  "authorization_information": "Информация",
  "authorization_error_newPasswordNoSpecified": "Новый пароль не указан",
  "authorization_error_PasswordsNomatch": "Пароли не совпадают",
  "authorization_changingUser": "Смена пользователя",
  "authorization_error_loginError": "Ошибка входа пользователя",
  "authorization_blockingAccessSystem": "Блокировка доступа к системе",
  "authorization_sessionDuration": "Длительность сессии",
  "authorization_passwordMinSize": "Минимальная длина пароля",
  "authorization_passwordNonRepeatingCount": "Количество неповторяемых паролей",
  "authorization_passwordExpirationTime": "Срок действия пароля",
  "authorization_passwordIsComplex": "Использовать сложный пароль",
  "authorization_passwordContainSpec": "Пароль должен содержать спецсимвол",
  "authorization_logout": "Выход из системы",
  "authorization_log_pass_error": "Неверное имя пользователя или пароль",
  "authorization_log_error": "Ошибка входа",
  //session
  "session_endSession": "Завершение сессии",
  "session_complete": "Завершить",
  //Тренд панель инстументов
  "trend_toolbar_autoscroll": "Автопрокрутка",
  "trend_toolbar_objTree": "Дерево объекта",
  "trend_toolbar_importCSV": "Открыть файл для отображения на тренде",
  "trend_toolbar_table": "Таблица",
  "trend_toolbar_export": "Экспорт",
  "trend_toolbar_pageContols": "Переключение страниц",
  "trend_toolbar_install": "Установить",
  "trend_toolbar_clearMark": "Сбросить",
  "trend_toolbar_kits": "Наборы",
  "trend_toolbar_log_disable": "Логарифмическая шкала",
  "trend_toolbar_log_active": "Включена логарифмическая шкала",
  "trend_toolbar_ydatazoom_disable": "Масштабирование полотна по оси Y",
  "trend_toolbar_ydatazoom_active": "Включено масштабирование полотна по оси Y",
  "trend_toolbar_xdatazoom_disable": "Масштабирование полотна по оси X",
  "trend_toolbar_xdatazoom_active": "Включено масштабирование полотна по оси X",
  "trend_toolbar_group": "Группы",
  "trend_toolbar_minilegenda": "Минилегенда",
  "trend_toolbar_print": "Печать",
  "trend_toolbar_exportGraph": "Экспорт графика",
  "trend_toolbar_reset": "Сброс",
  //наборы тренд
  "trend_kits_saveKit": "Сохранить набор",
  "trend_kits_choseKit": "Выбрать набор",
  "trend_kits_reset": "Сбросить",
  "trend_kits_errorUpload": "Набор с таким именем уже существует",
  "trend_kits_existAlert1": "Набор",
  "trend_kits_existAlert2": "уже существует, перезаписать?",
  "trend_kits_uploadKit": "Загрузить набор",
  "trend_kits_deleteSelectedKit": "Удалить выбранный набор",
  "trend_kits_newKit": "Новый набор",
  "trend_kits_renameTooltip": "Двойной клик для изменения имени",
  "trend_kits_KitNoCreate": "Наборы не созданы",
  "trend_kits_want_delete_set": 'Вы действительно хотите удалить набор',
  "trend_kits_no_sets_created": "Наборы не созданы",
  "trend_kits_select_set": "Выберите набор",
  // modal-template группа тренда
  "trend_kits_modal_save": "Сохранить",
  "trend_kits_modal_cancel": "Отмена",
  //группы тренд
  "trend_group_groups_pen": "Группы перьев",
  "trend_group_main_pen_tooltip": "Перо назначено главным в группе",
  "trend_group_all_pen": "Все перья",
  "trend_group_title": "Группы",
  "trend_group_no_group": "Групп нет",
  "trend_group_create_tooltip": "Создать новую группу",
  "trend_group_edit_tooltip": "Редактировать выбранную группу",
  "trend_group_delete_tooltip": "Удалить выбранную группу",
  //выбор перьев тренда
  "trend_objectTree_title": "Выбор перьев",
  "trend_objectTree_title_obj": "Выбор объектов",
  //минилегенда тренда
  "trend_legend_titleMinilegend": "Минилегенда",
  "trend_legend_checkbox": "Вкл.",
  "trend_legend_title": "Название",
  "trend_legend_value": "Значение",
  "trend_legend_color": "Цвет",
  //trend pen
  "trend_pen_no_archived": "Не архивируется",
  //trend table
  "trend_table_time": "Время",
  "trend_table_show": "Таблица значений",
  "trend_table_interpol": "Шаг отображения",
  "trend_table_clear": "Сбросить",
  "trend_table_lable_values": "Таблица значений (выбранный интервал)",
  "trend_table_select_step": "Выбрать шаг отображения",
  "trend_table_scale_tooltip": "Множитель периода интерполяции данных",
  //trend comtrade
  "trend_comtrade_title_modal": "Импорт осциллограммы",
  "trend_comtrade_title_format_modal": "Формат метки времени",
  "trend_comtrade_title_upload_btn" : "Выбор файлов осциллограммы",
  "trend_comtrade_upload_btn" : "Выбрать файлы",
  "trend_comtrade_uploaded" : "Загруженые файлы",
  "trend_comtrade_upload_error" : "Загружены не все файлы. Нужно загрузть .cfg и .dat",
  "trend_comtrade_parsing_error" : "Импортируемые файлы повреждены или указан неверный формат",
  //интервал тренлда selectDefault
  "trend_timeInterval_create": "Создать",
  "trend_timeInterval_sort": "Сортировать",
  "trend_timeInterval_all": "Все данные",
  "trend_timeInterval_select_day": "1 День",
  "trend_timeInterval_today": "Сегодня",
  "trend_timeInterval_today_tooltip": "Вернуться к текущей дате и времени",
  //trend error
  "trend_error": "Ошибка тренда",
  "trend_warning": "Предупреждение тренда",
  "trend_warning_not_all_added_params": "Не все параметры были добавлены в тренд",
  "trend_warning_not_added_exceed_limit": "не добавлено) из-за превышения ограничения",
  "trend_warning_no_one_added_params": "Ни один параметр не был добавлен тренд",
  //trendbase
  "trendbase_print_chart": "Печать графика",
  "trendbase_print_chart_to_printer": "Печать графика на принтер",
  "trendbase_pen_removed": "Удалено перо",
  "trendbase_added": "Добавлено",
  "trendbase_pens": "перьев",
  "trendbase_adding_removing": "Добавление/удаление перьев",
  //add to trend
  "add_to_trend_error": 'Ошибка действия "Добавить на тренд"',
  "trend_not_found": 'Тренд не найден',
  //Upload file
  "upload_upload_file": "Загрузить файл",
  "upload_drag_and_drop": "Перетащите сюда файл для загрузки",
  "upload_download": "Загрузить",
  "upload_select": "Выбрать файл",
  "upload_file_added": "Файл добавлен",
  "upload_file_complete": "Загрузка файла завершена",
  "upload_file_error": "Ошибка загрузки файла",
  //basic
  "basic_image": "Образ",
  "basic_not_standart": "не соотвествует принятому стандарту",
  //main
  "main_show_password": "Показать пароль",
  //chart
  "chart_XY_chart_is_empty": "График XY пуст",
  "chart_in_XY_chart": "В Графике XY",
  "chart_missing_feathers": "отсутствуют перья",
  //chartcolumn
  "chartcolumn_print_trend": "Печать тренда",
  "chartcolumn_creating_a_group_of_feathers": "Создание группы перьев",
  "chartcolumn_chart_warning": "Предупреждение диаграммы",
  "chartcolumn_feather_limit": "Превышен лимит перьев на диаграмме",
  "chartcolumn_pen": "Перо",
  "chartcolumn_was_not_added": "не было добавлено",
  "chartcolumn_your_interval": "Свой интервал",
  "chartcolumn_selecting_standart_intervals": "Выбор стандартных интервалов",
  "chartcolumn_print_to_printer": "Печать на принтер",
  "chartcolumn_print_diagram": "Печать диаграммы",
  "chartcolumn_export_data": "Экспорт данных",
  //ChartGroups
  "chartgroup_group_name": "Название группы",
  "chartgroup_cancel": "Отменить",
  "chartgroup_create_group": "Создать группу",
  "chartgroup_standart_group": "Стандартная группа",
  "chartgroup_name_cannot_be_empty": "Имя не может быть пустым",
  "chartgroup_group_name_exists": "Группа с таким именем уже существует",
  //ChartIntervals
  "chartintervals_last_year": "Последний год",
  "chartintervals_last_six_months": "Последние полгода",
  "chartintervals_current_month": "Текущий месяц",
  "chartintervals_last_week": "Последняя неделя",
  //ChartMenu
  "chartmenu_group_settings": "Настройки группы",
  "chartmenu_select_interval": "Выбрать интервал",
  "chartmenu_diagram_view": "Вид диаграммы",
  "chartmenu_net": "Сетка",
  "chartmenu_value_scale": "Шкала значений",
  "chartmenu_autoscaling": "Автомасштабирование",
  "chartmenu_accumulation": "Накопление",
  "chartmenu_reset_settings": "Сбросить настройки",
  "chartmenu_save_image": "Сохранить изображение",
  //ChartMenuInterval
  "interval_sunday": "Воскресенье",
  "interval_monday": "Понедельник",
  "interval_tuesday": "Вторник",
  "interval_wednesday": "Среда",
  "interval_thursday": "Четверг",
  "interval_friday": "Пятница",
  "interval_saturday": "Суббота",
  "interval_sun": "Вос",
  "interval_mon": "Пон",
  "interval_tue": "Вто",
  "interval_wed": "Сре",
  "interval_thur": "Чет",
  "interval_fri": "Пят",
  "interval_sat": "Суб",
  "interval_su": "Вс",
  "interval_mo": "Пн",
  "interval_tu": "Вт",
  "interval_we": "Ср",
  "interval_th": "Чт",
  "interval_fr": "Пт",
  "interval_sa": "Сб",
  "interval_january": "Январь",
  "interval_february": "Февраль",
  "interval_march": "Март",
  "interval_april": "Апрель",
  "interval_may": "Май",
  "interval_june": "Июнь",
  "interval_july": "Июль",
  "interval_august": "Август",
  "interval_september": "Сентябрь",
  "interval_october": "Октябрь",
  "interval_november": "Ноябрь",
  "interval_december": "Декабрь",
  "interval_jan": "Янв",
  "interval_feb": "Фев",
  "interval_mar": "Мар",
  "interval_apr": "Апр",
  "interval_ma": "Май",
  "interval_jun": "Июн",
  "interval_jul": "Июл",
  "interval_aug": "Авг",
  "interval_sep": "Сен",
  "interval_oct": "Окт",
  "interval_nov": "Ноя",
  "interval_dec": "Дек",
  "interval_today": "Сегодня",
  "interval_clear": "Очистить",
  "interval_division": "Деление",
  "interval_start_of_archive": "Начало архива",
  "interval_end_of_archive": "Конец архива",
  "interval_setting_intervals": "Настройки интервалов",
  //ChartMenuPens
  "chartmenupens_value": "Значение",
  "chartmenupens_last": "Последнее",
  "chartmenupens_average": "Среднее",
  "chartmenupens_minimum": "Минимум",
  "chartmenupens_maximum": "Максимум",
  "chartmenupens_difference": "Разница",
  "chartmenupens_type": "Вид",
  "chartmenupens_color": "Цвет",
  "chartmenupens_name": "Название",
  "chartmenupens_type_of_value": "Вид значения",
  "chartmenupens_select_pens": "Выбрать перья",
  "chartmenupens_group_setting": "Настройка группы",
  "chartmenupens_changing": "Изменение настройки перьев",
  //State
  "state_standart_group": "Стандартная группа",
  //Datatable
  "datatable_export_data": "Экспорт данных",
  "datatable_columnFilterEnabled": "Включена фильтрация столбца",
  "datatable_columnFilterDisabled": "Отключена фильтрация столбца",
  "datatable_changing_an_entry": "Изменение записи",
  "datatable_edit": "Редактирование",
  "incorrect_value_entered": "Введено некорректное значение",
  "use_positive_numbers_or_*.": "Введено некорректное значение. Используйте положительные числа или *",
  //Mark
  "mark_edit_comment": "Редактировать комментарий",
  "mark_add_comment": "Добавить комментарий",
  "mark_delete": "Удалить метку",
  "mark_enter_comment": "Введите комментарий",
  "mark_user": "ПОЛЬЗОВАТЕЛЬ",
  "mark_comment": "КОММЕНТАРИЙ",
  "mark_time": "ВРЕМЯ",
  //Polygon
  "polygon_primitive_error": "Ошибка примитива",
  "polygon_enable_set_value": "Невозможно задать значение",
  "polygon_geometry_for": 'параметру "Геометрия" для',
  //Журнал панель инстументов
  "jornal_toolbar_acknowledgePage": "Квитировать на странице",
  "jornal_toolbar_acknowledgeAll": "Квитировать все",
  "jornal_toolbar_export": "Экспорт",
  "jornal_toolbar_print": "Печать",
  "jornal_toolbar_priority": "Приоритет",
  "jornal_toolbar_objectTree": "Дерево объекта",
  "jornal_toolbar_timeFilter": "Включить фильтр по времени",
  "jornal_toolbar_goDate": "Перейти к дате",
  "jornal_toolbar_showLegend": "Показать легенду",
  "jornal_toolbar_autoscroll": "Автопрокрутка",
  "jornal_toolbar_showFilter": "Показать фильтр",
  "jornal_toolbar_reset": "Сброс",
  "jornal_toolbar_goFirstPage": "К первой странице",
  "jornal_toolbar_goLastPage": "К последней странице",
  //Журнал приоритет
  "jornal_priority_title": "Приоритет",
  "jornal_priority_filter": "Фильтр",
  //Журнал фильтр времени
  "jornal_timeFilter_skipped": "Пропущено",
  "jornal_timeFilter_displayedInterval": "Отображаемый интервал",
  "jornal_timeFilter_numberMessages": "Количество сообщений",
  "jornal_timeFilter_time": "Время",
  "jornal_timeFilter_autoscrollTime": "Автопрокрутка Время",
  //Журнал перейти к дате
  "jornal_goDate_title": "Перейти к дате",
  //Журнал
  "jornal_filterTitle": "Фильтр1",
  "jornal_columnFilterEnabled": "Включена фильтрация столбца",
  "jornal_columnFilterDisabled": "Отключена фильтрация столбца",
  "jornal_contains": "содержит",
  "jornal_equal": "равен",
  "jornal_equally": "равно",
  "jornal_acknowledged": "Квитировано",
  "jornal_enterComment": "Введите комментарий",
  "jornal_addEventFavoriteTooltip": "Добавьте событие в избранное, кликнув дважды на ячейку",
  "jornal_filterEnabled": "Включен фильтр",
  "jornal_filterDisabled": "Отключен фильтр",
  "jornal_acknowledgedMessages": "сообщений",
  "jornal_savingMessagesFile": "Сохранение сообщений в файл",
  "jornal_ack": "квит",
  "journal_time": "Время",
  "journal_message": "Сообщение",
  "journal_priority": "Приоритет",
  "journal_withdrawal_time": "Время снятия",
  "journal_kvit_time": "Время квитирования",
  "journal_user": "Пользователь",
  "journal_comment": "Комментарий",
  "journal_event": "Событие",
  "journal_kvitirovanie": "Квитированность",
  "journal_appearance": "Появление",
  "journal_login": "Вход в систему",
  "journal_logout": "Выход из системы",
  "journal_startSession": "старт сессии",
  "journal_activation_time": "Время активации",
  "journal_active_messages": "Активные сообщения",
  "journal_icon": "Иконка",
  "journal_EventFullObjectName": "Полное имя объекта",
  "journal_EventObjectName": "Объект",
  "journal_EventSourceName": "Источник",
  "journal_EventSourceOrObjectName": "Источник или объект",
  "journal_EventDescription": "Описание",
  "journal_EventDescriptionOrSource": "Описание или источник",
  "journal_EventState": "Состояние",
  "journal_EventStateSeverity": "Состояние+Приоритет",
  "journal_ClientAddress": "IP адрес/Имя устройства",
  "journal_ClientIpAddress": "IP адрес",
  "journal_ClientHostName": "Имя устройства",
  "journal_window": "Окно",
  "journal_ExternalPath": "Внешний источник",
  "journal_ActiveTime": "Время активации",
  "journal_Severity": "Приоритет",
  "journal_Active": "Активность",
  "journal_InactiveTime": "Время деактивации",
  "journal_AckedTime": "Время квитирования",
  "journal_value": "Значение",
  "journal_MaxChangeRate": "Максимальная скорость изменения",
  "journal_disappearance": "Исчезновение",
  "journal_safety": "Безопасность",
  "journal_alarm": "Тревога",
  "journal_object": "Объект",
  "journal_attention": "Внимание",
  "journal_ALARM": "ТРЕВОГА",
  "journal_objects": "Объекты",
  "journal_printMessages": "Печать сообщений на принтер",
  "journal_ack": "Квитирование",
  //Справочник тулбар
  "dictionary_toolbar_reload": "Обновить",
  "dictionary_toolbar_add": "Добавить",
  "dictionary_toolbar_edit": "Редактировать",
  "dictionary_toolbar_delete": "Удалить",
  "dictionary_toolbar_reset": "Сброс",
  //Справочник
  "dictionary_title_filter_for": "Фильтр для",
  "dictionary_contains": "cодержит",
  "dictionary_equals": "равно",
  "dictionary_column_filtering_enabled": "Включена фильтрация столбца",
  "dictionary_column_filtering_is_disabled": "Отключена фильтрация столбца",
  "dictionary_adding_a_record": "Добавление записи",
  "dictionary_addition": "Добавление",
  "dictionary_changing_an_entry": "Изменение записи",
  "dictionary_editing": "Изменение",
  "dictionary_deleting_a_record": "Удаление записи",
  "dictionary_export_data": "Экспорт данных",
  "dictionary_city": "Город",
  "dictionary_street": "Улица",
  "dictionary_house": "Дом",
  "dictionary_building": "Корпус",
  //дерево
  "tree_clear_tooltip": "Восстановить по умолчанию",
  //легенда
  "legend_tooltip_visible": "Видимость",
  "legend_title_pen": "Перо",
  "legend_tooltip_pen": "Графические атрибуты пера",
  "legend_title_name": "Имя",
  "legend_tooltip_name": "Имя пера",
  "legend_title_source": "Источник",
  "legend_tooltip_source": "Путь к переменной, связанной с пером",
  "legend_title_group": "Группа",
  "legend_tooltip_group": "Группа пера",
  "legend_title_units": "Ед.изм.",
  "legend_tooltip_units": "Единицы измерения",
  "legend_title_value": "Значение",
  "legend_tooltip_value": "Значение переменной, связанной с пером",
  "legend_title_avarage": "Ср. Значение",
  "legend_tooltip_avarage": "Среднее значение",
  "legend_title_comment": "Комментарий",
  "legend_tooltip_comment": "Комментарий параметра",
  "legend_title_lasttime": "Вр.посл.",
  "legend_tooltip_lasttime": "Время последнего изменения значения",
  "legend_title_isbad": "Кач-во.",
  "legend_tooltip_isbad": "Признак качества",
  "legend_title_scalemin": "Шк.Мин.",
  "legend_tooltip_scalemin": "Минимальное значение шкалы",
  "legend_title_scalemax": "Шк.Макс",
  "legend_tooltip_scalemax": "Максимальное значение шкалы",
  "legend_title_lolo": "НАУ",
  "legend_tooltip_lolo": "Нижняя аварийная уставка. (LoLo)",
  "legend_title_lo": "НПУ",
  "legend_tooltip_lo": "Нижняя предупреждающая уставка. (Lo)",
  "legend_title_hi": "ВПУ",
  "legend_tooltip_hi": "Верхняя предупреждающая уставка. (Hi)",
  "legend_title_hihi": "ВАУ",
  "legend_tooltip_hihi": "Верхняя аварийная уставка. (HiHi)",
  "legend_title_start": "Нач.знач.",
  "legend_tooltip_start": "Значение переменной в начале диапазона",
  "legend_title_min": "Мин.знач.",
  "legend_tooltip_min": "Минимальное значение переменной в диапазоне",
  "legend_title_max": "Макс.знач.",
  "legend_tooltip_max": "Максимальное значение переменной в диапазоне",
  "legend_title_end": "Кон.знач.",
  "legend_tooltip_end": "Значение переменной в конце диапазона",
  "legend_menu_type_graph_title": "Тип графика",
  "legend_menu_type_graph_linear": "Линейный",
  "legend_menu_type_graph_stepped": "Ступенчатый",
  "legend_menu_thickness_title": "Tолщина",
  "legend_menu_color_title": "Цвет",
  "legend_menu_type_line_title": "Стиль линии",
  "legend_menu_type_line_line": "Линия",
  "legend_menu_type_line_dotted": "Пунктир",
  "legend_menu_type_line_points": "Точки",
  "legend_menu_type_point_title": "Вид точки",
  "legend_menu_point_size_title": "Размер точки",
  "legend_menu_scale_visibility_title": "Видимость шкалы",
  "legend_menu_ddding_constants_title": "Дорисовка констант",
  "legend_menu_autoscaling_title": "Автомасштабирование",
  "legend_scale_no_use": "Шкала не используется",
  "legend_scale_no_use_tooltip": "Перо не выбрано главным в группе",
  "legend_autoscaling_on": "Автомасштабирование",
  //numericupdown
  "numericupdown_tooltip": "от {Минимум} до {Максимум}",
  "numericupdown_tooltip_without_min": "до {Максимум}",
  "numericupdown_tooltip_without_max": "от {Минимум}",
  "numericupdown_popup_description_start": "Недопустимое значение. Введите число",
  // paneltabcontrol Панель вкладок
  "paneltabcontrol_tab_not_found_title": "Вкладка \"{}\" не найдена",
  "paneltabcontrol_tab_not_found_text": "Предупреждение 'Активная вкладка': задан номер несуществующей вкладки на панели вкладок \"{}\"",
  "paneltabcontrol_tab_is_hidden_title": "Вкладка \"{}\" невидимая",
  "paneltabcontrol_tab_is_hidden_text": "Предупреждение 'Активная вкладка': задан номер скрытой вкладки на панели вкладок \"{}\". Действие будет проигнорировано",
  //Интервалы
  "interval_millisecond": "Миллисекунда",
  "interval_second": "Секунда",
  "interval_minute": "Минута",
  "interval_hour": "Час",
  "interval_day": "День",
  "interval_month": "Месяц",
  "interval_year": "Год",
  //Интервалы сокращённые
  "interval_short_millisecond": "Мс",
  "interval_short_second": "Сек",
  "interval_short_minute": "Мин",
  "interval_short_hour": "Час",
  "interval_short_day": "День",
  "interval_short_month": "Мес",
  "interval_short_year": "Год",
  "interval_from": "От",
  "interval_to": "До",
  //upload
  "upload_drag": "Чтобы выбрать файл, нажмите на кнопку или перетащите его сюда",
  //кнопки
  "cancel": "Отмена",
  "apply": "Применить",
  "choose": "Выбрать",
  "delete": "Удалить",
  "confirm": "Подтвердить",
  "all": 'Все',
  "ok": "Ок",
  "open": "Открыть",
  "import": "Импорт",
  //bool
  "true": "Да",
  "false": "Нет",
  //any
  "search": "Поиск",
  "loading": "Загрузка",
  "indefinitely": "Неопределено",
  "warning": "Предупреждение",
  "title_error_setting_value": "Ошибка установки значения",
  "title_error_setting_link": "Ошибка установки значения по связи",
  "title_error_creating_link": "Ошибка при создании связи",
  "title_error_setting_trigger": "Ошибка при вызове триггера",
  "request_cannot": "запрос не может быть разобран парсером JSON",
  "invalid_parametr": "передан недействительный Id параметра/выборки",
  "connection_error": "Ошибка подключения",
  "number_of_connection": "Превышено разрешенное число подключений к серверу",
  "visualisation_isnot_available": "визуализация недоступна в этом проекте",
  "request_method_not_recognized": "метод запроса не опознан",
  "from_lower": "от",
  "to_lower": "до",
  // СПИСОК СИСТЕМНЫХ ОШИБОК HMI (ns.add)
  //Окно не найдено
  "title_window_not_found": "Окно не найдено",
  // Окно по пути ... не найдено
  "window_not_found_path": "Окно по пути {} не найдено",
  // Образ не соответствует принятому стандарту
  "image_not_standart": "Образ {} id={} не соответствует принятому стандарту",
  // В графике XY отсутствуют перья
  "chartXY_missing_pens": `В графике XY {} отсутствуют перья`,
  // Превышен лимит перьев на диаграмме. Перо не было добавлено
  "diagram_pens_limit": `Превышен лимит перьев на диаграмме. Перо {} не было добавлено`,
  // Ошибка получения данных
  "title_dictionary_error_retrieving_data": "Ошибка получения данных",
  // Ошибка сохранения
  "title_dictionary_error_saving": "Ошибка сохранения",
  // Ошибка удаления
  "title_dictionary_error_deleting": "Ошибка удаления",
  // Невозможно задать значение параметру "Геометрия" для
  "polygon_cannot_set_value": 'Невозможно установить значение {} для параметра "Геометрия" для id={} {}',
  // Не все параметры были добавлены в тренд ... не добавлено) из-за превышения ограничения
  "trend_not_all_added_params": `Не все параметры были добавлены в тренд ({}) из-за превышения ограничения ({})`,
  // Ни один параметр не добавлен из-за превышения ограничения
  "trend_not_one_added_params": `Ни один параметр не добавлен ({}) из-за превышения ограничения ({})`,
  // Выбранный файл не является CSV-файлом
  "trendcsv_import_file_not_svg": `Выбранный файл не является CSV-файлом`,
  // Импортируемый файл повреждён или имеет неверный формат
  "trendcsv_import_file_broken": `Импортируемый файл повреждён или имеет неверный формат`,
  // Некорректно задана маска ввода
  "input_mask_incorrect": "Некорректно задана маска ввода",
  // Недопустимое значение цвета {0} для перевода в матрицу. По умолчанию будет использоваться единичная матрица
  "color_error_matrix": "Недопустимое значение цвета {} для перевода в матрицу. По умолчанию будет использоваться единичная матрица",
  // Ошибка параметра
  "title_parametr_error": "Ошибка параметра",
  // Невозможно получить параметр
  "cannot_get_parametr": `Невозможно получить параметр {}/{}`,
  // Не найдено действие
  "title_action_not_found": "Не найдено действие",
  // Не найдено действие
  "action_not_found_error": "Не найдено действие {} ControlId={}",
  // Ошибка операции
  "title_operation_error": "Ошибка операции",
  // Элемент с id не найден
  "element_id_not_found": `Элемент с id {} не найден`,
  // Ошибка установки значения на параметр в контроле
  "value_setting_error": "Ошибка установки значения {} на параметр {} в контроле id={}{}",
  "link_setting_error": "Ошибка установки значения {} по связи {} на параметр {} в контроле id={} \"{}\"",
  "link_creating_error": "Ошибка при создании связи на параметр {} в контроле id={} \"{}\"",
  "trigger_setting_error": "Ошибка установки значения {} в условии триггера с id={} на параметр условия триггера с id={} в контроле id={} \"{}\"",
  // Нет прав на открытие заданного стартового окна
  "not_rights_to_open": "Нет прав на открытие заданного стартового окна. Проверьте настройки прав для данного пользователя",
  // Нет прав на заданное окно
  "title_not_rights_to_window": "Нет прав на заданное окно",
  // Соединение установлено
  "title_connection_established": "Соединение установлено",
  // Подключение к ... успешно установлено
  "connection_success": `Подключение к {} успешно установлено`,
  // Звук не найден
  "sound_not_found": "Звук не найден: {}",
  // Ошибка входа пользователя
  "authorization_error_login": "Ошибка входа пользователя {}. {} || {}",
  // Вызов POU ошибка
  "title_call_pou_error": "Вызов POU ОШИБКА",
  // Айди программы
  "program_id": "ID программы {}",
  // Предупреждение образа
  "title_skin_warning": "Предупреждение образа",
  // Неправильный идентификатор тренда
  "title_wrong_id_trend": "Неправильный идентификатор тренда",
  // ID легенды ... установил неправильный идентификатор тренда ...
  "wrong_id_trend_set": "ID легенды: {} установил неправильный идентификатор тренда: {}",
  // Ошибка записи файла
  "title_write_file_error": "Ошибка записи файла",
  // Ошибка записи файла
  "write_file_errors": "Ошибка записи файла: {} {} {}",
  // Невозможно подписаться на параметр
  "unable_to_subscribe_to_parameter": "Невозможно подписаться на параметр",
  // FROM id ... TO id ... Значение ... не может быть преобразовано в формат ...
  "cannot_be_converted": "Значение {} не может быть преобразовано в формат {}",
  "open_win_error": "Ошибка открытия окна ",
  //PathResolver
  "pathresolver_resources": "Ресурсы",
  "pathresolver_windows": "Окна",
  "pathresolver_graphic_user_interface": "Графический интерфейс",
  //Bim
  "bim_focus_object_error": 'Ошибка выполнения команды "Сфокусировать объект" BIM сервера',
  "bim_no_websocket_connection": "Отсутствует соединение по протоколу WebSocket",
  //permission
  "action": "Действие",
  "control": "Управление",
  "open_window": "Открытие окна",
  "change_users": "Смена пользователя",
  "change_password": "Сменить пароль",
  "journal_group_ack": "Групповое квитирование сообщений",
  "journal_use_filters": "Использование фильтров в журнале",
  "journal_print": "Печать сообщений",
  "journal_save": "Экспорт сообщений",
  "trend_add_pens": "Изменение состава перьев",
  "trend_change_pens": "Изменение настройки перьев, изменение шкалы",
  "trend_save": "Экспорт графика",
  "trend_print": "Печать графика",
  "data_table_edit": "Редактирование ячеек таблицы",
  "data_table_filter": "Использование фильтров в таблице",
  "insufficient_permissions": "Недостаточно прав для выполнения действия",

  //Mark
  "marks": "Метки",
  "posters": "Плакаты",
  "installed_individually": "Плакаты Транзит разомкнут , Работа под напряжением и диспетчерские пометки устанавливаются одиночно",
  "mark_selection": "Выбор метки",
  "poster_selection": "Выбор плаката",
  "no_image": "Нет изображения",
  "dispatcher_marks": "Диспетчерские пометки",
  "delete_all_marks": "Удалить все метки",
  "show_all_marks": "Показать все метки",
  "hide_all_marks": "Скрыть все метки",
  "break_connection": "Разорвать связь",
  "edit_comment": "Изменить комментарий",
  "add_comment": "Добавить комментарий",
  "no_more_connection": "Запрещено устанавливать больше одной связи с меткой",
  "all_marks_hide": "Все добавленные на окно метки скрыты",
  "mark_user_comment": "Комментарий",
  "mark_username": "Пользователь",
  "mark_last_change": "Последнее изменение",
  "uncorrect_data": "Некорректные данные",
  "unavailable_side": "Сторона недоступна для установки связи",
  "poster": "Плакат",
  "mark": "Метка",
  "delete_all": "Удалить все",
  "show_all": "Показать все",
  "hide_all": "Скрыть все",
  "close": "Закрыть",
  "mark_priority": "Приоритет метки",
  "poster_priority": "Приоритет плакаты",
  "delmark": "метку",
  "delposter": "плакат"
} as const